module.exports = __webpack_public_path__ + "static/media/colicoli20.721e3601.webp";